import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import { useCustomSnackbar } from '../../hooks/useCustomSneakbar';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';

const SectionExamRequest = () => {
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()

    let instituteMasterId = localStorage.getItem("instituteMasterId")
    let sectionMasterId = localStorage.getItem("sectionMasterId")

    const [requestList, setRequestList] = useState([]);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getReLoginRequestList();
    }, []);

    const getReLoginRequestList = () => {
        const apiUrl = `/get-student-exam-request?section_id=${sectionMasterId}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setRequestList(response.data.data)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleRequest = (id, status) => {
        const apiUrl = `/update-student-exam-request?id=${id}`;
        authorizedAxiosSection && authorizedAxiosSection.patch(apiUrl, { status })
            .then(response => {
                getReLoginRequestList();
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    return (
        <>
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />

                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Exam Request</span></li>
                        </ol>
                    </nav>
                </div>

                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fas fa-user-clock"></i>Exam Request</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">

                                            <div className="row">
                                                <div className="d-grid gap-2 mt-2">

                                                    {
                                                        requestList.length > 0 ?
                                                            requestList.map((request) => (
                                                                <>
                                                                    {(request.status === 1) && (
                                                                        <div className="alert alert-warning alert-dismissible fade show d-flex align-items-center p-3" role="alert" style={{ borderRadius: '10px' }}>
                                                                            <div className="flex-grow-1">
                                                                                <strong>Pending:</strong> A student named {request.StudentMaster.studentName} has requested to Exam. Do you want to approve?
                                                                                <div>Exam Name: {request.ExamMaster.exam_name}</div>
                                                                                <div>Class Name: {request.InstituteGradeMaster.gradeName}</div>
                                                                                <div>Division Name: {request.InstituteDivisionMaster.divisionName}</div>
                                                                            </div>
                                                                            <div className="d-flex">
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn-approve-custom mx-1"
                                                                                    aria-label="Approve"
                                                                                    onClick={() => handleRequest(request.id, '2')}
                                                                                >
                                                                                    <i className="fas fa-check"></i>
                                                                                </button>
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn-reject-custom mx-1"
                                                                                    aria-label="Reject"
                                                                                    onClick={() => handleRequest(request.id, '3')}
                                                                                >
                                                                                    <i className="fas fa-times"></i>
                                                                                </button>
                                                                            </div>
                                                                        </div>)}
                                                                    {(request.status === 2) && (
                                                                        <div className="alert alert-success alert-dismissible fade show d-flex align-items-center p-3" role="alert" style={{ borderRadius: '10px' }}>
                                                                            <div className="flex-grow-1">
                                                                                <strong>Approved:</strong> {request.StudentMaster.studentName} Exam request was approved.
                                                                                <div>Exam Name: {request.ExamMaster.exam_name}</div>
                                                                                <div>Class Name: {request.InstituteGradeMaster.gradeName}</div>
                                                                                <div>Division Name: {request.InstituteDivisionMaster.divisionName}</div>
                                                                            </div>
                                                                        </div>)}
                                                                    {(request.status === 3) && (
                                                                        <div className="alert alert-danger alert-dismissible fade show d-flex align-items-center p-3" role="alert" style={{ borderRadius: '10px' }}>
                                                                            <div className="flex-grow-1">
                                                                                <strong>Rejected:</strong> {request.StudentMaster.studentName} Exam request was rejected.
                                                                                <div>Exam Name: {request.ExamMaster.exam_name}</div>
                                                                                <div>Class Name: {request.InstituteGradeMaster.gradeName}</div>
                                                                                <div>Division Name: {request.InstituteDivisionMaster.divisionName}</div>
                                                                            </div>
                                                                        </div>)}
                                                                </>
                                                            ))
                                                            :
                                                            <div style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                                                                <strong>No Request Available</strong>
                                                            </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default SectionExamRequest
